import { computed, observable, set } from 'mobx';
import { SAMPLE_ITEM } from '../../utils/Constants';

export interface IShipmentItem {
    name: string;
    subheading: string;
    quantity: string;
    sku_id: string;
    sku_image: string;
    sku_url: string | null;
    size: string | null | undefined;
    hex_value: string | null;
    shade_name: string | null;
    sku_type: string | null;
    is_free_promo: number;
}

export class ShipmentItem {
    @observable public name: string;
    @observable public subheading: string;
    @observable public quantity: string;
    @observable public sku_id: string;
    @observable public sku_image: string;
    @observable public sku_url: string | null;
    @observable public size: string | null | undefined;
    @observable public hex_value: string | null;
    @observable public shade_name: string | null;
    @observable public sku_type: string | null;
    @observable public is_promo: boolean;

    @computed
    /**
     * The business does not want users to click through to URLs for
     * Promotion Items or Sample Items or if the there is no URL.
     */
    public get isLinkEnabled(): boolean {
        return !this.is_promo && !this.is_sample && !!this.sku_url;
    }

    /**
     * PG API sends a string value for SKU type (i.e. 'Samples')
     *
     * @see SAMPLE_ITEM
     */
    private get is_sample(): boolean {
        return this.sku_type === SAMPLE_ITEM;
    }

    /**
     *
     * @param json "Shipment Item" data from our PG API
     * @returns a new ShipmentItem
     */
    public static fromJSON(json: IShipmentItem): ShipmentItem {
        const item: ShipmentItem = new ShipmentItem();

        const {
            hex_value,
            is_free_promo,
            name,
            quantity,
            shade_name,
            size,
            sku_id,
            sku_image,
            sku_type,
            sku_url,
            subheading
        } = json;

        set(item, {
            hex_value,
            name,
            quantity,
            shade_name,
            size,
            sku_id,
            sku_image,
            sku_type,
            sku_url,
            subheading
        });

        item.is_promo = Boolean(is_free_promo);

        return item;
    }
}
